import { render, staticRenderFns } from "./LogisticsHolidayInfoModal.vue?vue&type=template&id=02416619&scoped=true"
import script from "./LogisticsHolidayInfoModal.vue?vue&type=script&lang=js"
export * from "./LogisticsHolidayInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02416619",
  null
  
)

export default component.exports